

import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';

export const relationSettingsDetailsConfig = {
    business:  {
        title: 'company',
        icon: <UpdateOutlinedIcon />,
    },
};

